// src/api/leadTimeline.ts
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}/lead`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};

const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  toast.error(detail);
};

export interface LeadHistoryItem {
  changed_fields: string[];
  changed_values: Record<
    string,
    {
      old: string;
      new: string;
    }
  >;
  modified_at: string;
  modified_by: string;
}

export interface LeadHistoryResponse {
  lead_created_at: string;
  lead_history: LeadHistoryItem[];
}

export const fetchLeadHistory = async (
  leadId: string
): Promise<LeadHistoryResponse> => {
  try {
    const res = await axios.get(`${BASE_URL}/history/${leadId}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (error) {
    showAxiosError(error, "Failed to fetch lead history");
    throw error;
  }
};
